import { Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { MixRead } from "src/store/api/generatedApi";
import { OverrideMixDetails } from "./OverrideMixDetails";

export const formatOverrideReason = ({
  reason,
  subreason,
}: {
  reason: string | null;
  subreason: string | null;
}) => [reason, subreason].filter((part) => part !== null).join(" — ");

export const OverrideMixComparison = ({
  replacedMix,
  overrideMix,
  recipeName,
}: {
  replacedMix: MixRead;
  overrideMix: MixRead;
  recipeName: string | null;
}) => {
  const { t } = useTenantTranslation();
  return (
    <Stack direction={{ xs: "column", sm: "row" }} sx={{ gap: 2 }}>
      <OverrideMixDetails title={t("originalMix")} mix={replacedMix} />
      <OverrideMixDetails
        title={t("overrideNamed", { name: recipeName ?? "—" })}
        mix={overrideMix}
      />
    </Stack>
  );
};

export const OverrideComment = ({ comment }: { comment: string | null }) => {
  const { t } = useTenantTranslation();
  if (!comment) {
    return null;
  }
  return (
    <Stack sx={{ gap: 0.5 }}>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {t("comment")}
      </Typography>
      <Typography
        variant="body2"
        sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
      >
        {comment}
      </Typography>
    </Stack>
  );
};
